import { CALL_API, Schemas } from '../../common/middleware/api';

export const PAYMENTS_REQUEST = 'PAYMENTS_REQUEST';
export const PAYMENTS_SUCCESS = 'PAYMENTS_SUCCESS';
export const PAYMENTS_FAILURE = 'PAYMENTS_FAILURE';

export const PAYMENT_FETCH_REQUEST = 'PAYMENT_GET_REQUEST';
export const PAYMENT_FETCH_SUCCESS = 'PAYMENT_GET_SUCCESS';
export const PAYMENT_FETCH_FAILURE = 'PAYMENT_GET_FAILURE';

export const SET_SUBGRADE_REQUEST = 'SET_SUBGRADE_REQUEST';
export const SET_SUBGRADE_SUCCESS = 'SET_SUBGRADE_SUCCESS';
export const SET_SUBGRADE_FAILURE = 'SET_SUBGRADE_FAILURE';

export const PaymentTypes = {
	Lesson: 'lesson',
	IndividualConsultation: 'individualConsultation',
	Workshop: 'workshop'
}

export const loadPayments = (options) => ({
	[CALL_API]: {
		types: [PAYMENTS_REQUEST, PAYMENTS_SUCCESS, PAYMENTS_FAILURE],
		endpoint: 'api/payments',
		request: options,
		schema: Schemas.PAYMENT_ARRAY
	}
});

export const fetchPayment = (id, type) => ({
	[CALL_API]: {
		types: [PAYMENT_FETCH_REQUEST, PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE],
		endpoint: `api/payments/${type}/${id}`,
		schema: Schemas.PAYMENT
	}
});


export const setPaymentSubGrade = (paymentId, gradeId, onSuccess) => ({
	[CALL_API]: {
		types: [SET_SUBGRADE_REQUEST, SET_SUBGRADE_SUCCESS, SET_SUBGRADE_FAILURE],
		endpoint: `api/payments/${paymentId}/${gradeId}`,
		method: 'PUT',
		onSuccess: onSuccess
	}
});